/* eslint-disable import/first */
import { setPublicPath } from 'systemjs-webpack-interop';
setPublicPath('FLAGS', 3);
import React from 'react';
import ReactDOM from 'react-dom';
import SingleSpaReact from 'single-spa-react';
import SetupApprovalsDialog from './app/flag_manager/pages/rules/components/configure_rule/modals/SetupApprovalsDialog';
import { FeatureFlagProvider } from './app/flags_main/context/FeatureFlag.context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

interface SetupApprovalsDialogParcelProps {
  closeDialog: () => void;
  domElement: HTMLElement;
  entityId: string;
  entityKey: string;
  entityName: string;
  entityType: string;
  projectId: string;
}

const loadRootComponent = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "App" */ 'app').then(
    module => module.default
  );

const reactLifecycles = SingleSpaReact({
  loadRootComponent,
  React,
  ReactDOM,
});

export const bootstrap = reactLifecycles.bootstrap;
export const mount = reactLifecycles.mount;
export const unmount = reactLifecycles.unmount;

const FlagsApplication = {
  bootstrap,
  mount,
  unmount,
};

export const SetupApprovalsDialogParcel = {
  async mount(props: SetupApprovalsDialogParcelProps) {
    const {
      domElement,
      projectId,
      entityName,
      entityType,
      entityId,
      entityKey,
      closeDialog,
    } = props;

    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnMount: true,
          refetchOnWindowFocus: false,
          staleTime: 0,
        },
      },
    });

    ReactDOM.render(
      React.createElement(
        QueryClientProvider,
        { client: queryClient },
        React.createElement(
          FeatureFlagProvider,
          null,
          React.createElement(SetupApprovalsDialog, {
            closeDialog,
            entityId,
            entityKey,
            entityName,
            entityType,
            projectId,
          })
        )
      ),
      domElement
    );
  },
  async unmount(props: { domElement: HTMLElement }) {
    const { domElement } = props;
    ReactDOM.unmountComponentAtNode(domElement);
  },
};

export default FlagsApplication;
